export default {
  en: {
    'ok': 'ok',
    'close': 'close',
    'cancel': 'cancel',
    'apply': 'apply',
    'finish': 'finish',
    'start': 'start',
    'once': 'once',
    'once_price': 'once_price',
    'monthly_price': 'monthly_price',
    'abort': 'abort',
    'progress': 'progress',
    'country': 'country',
    'settings': 'settings',
    'current_day_x': '{day}. day',
    'current_season_x': '{season}. season',
    'not_saved_game_progress_will_be_lost': 'Not saved game progress will be lost!',
    'sure_you_want_to_quit?': 'Sure you want to quit?',
    'days': {
      'short': {
        1: 'mon',
        2: 'tus',
        3: 'wed',
        4: 'thu',
        5: 'fri',
        6: 'sat',
        7: 'sun',
      },
    },
    'debug': 'debug',
    'skip': 'skip',
    'processing...': 'processing...',
    'welcome_to_your_new_team': 'welcome to your new team: {team}',
    'welcome': 'welcome',
    'your_initial_balance': 'your initial balance: {balance}',
    'good_luck': 'Good luck!',
    'gk': 'gk',
    'ld': 'ld',
    'cd': 'cd',
    'rd': 'rd',
    'lm': 'lm',
    'dm': 'dm',
    'cm': 'cm',
    'om': 'om',
    'rm': 'rm',
    'lw': 'lw',
    'fw': 'fw',
    'rw': 'rw',
    '': '',
  }
};